import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import React, { useMemo, useState, useEffect } from "react";
import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import EditBusinessUnit from "./EditBusinessUnit";
import axios from "axios";

export default function BusinessUnitsTable(props) {
  const { columnsData, tableData } = props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const [data, setData] = useState(tableData);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = data.length;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null);
  const [isNew, setIsNew] = useState(false);

  const handleEdit = (businessUnit) => {
    setSelectedBusinessUnit(businessUnit);
    setIsNew(false);
    onOpen();
  };

  const handleCreate = () => {
    setSelectedBusinessUnit({
      business_unit_id: "",
      name: "",
      description: "",
      annual_revenue: "",
      asset_count: "",
    });
    setIsNew(true);
    onOpen();
  };

  const fetchBusinessUnits = () => {
    const uri = process.env.REACT_APP_AWS_FLASK_BASE_URI + `/business_units`;
    console.log(uri);
    const data = {
      "api_key": process.env.REACT_APP_AWS_FLASK_API_KEY
    }
    axios.post(uri, data)
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the business units!", error);
      });
  };

  useEffect(() => {
    fetchBusinessUnits();
  }, []);

  const handleModalClose = () => {
    onClose();
    fetchBusinessUnits();
  };

  const handleRefresh = () => {
    console.log("Refresh...");
    fetchBusinessUnits();
  };

  return (
    <Card direction="column" w="100%" px="0px" overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text color={textColor} fontSize="22px" fontWeight="700" lineHeight="100%">
          Business Lines
        </Text>
        <Flex justify="flex-end" align="center">
          <Button colorScheme="teal" onClick={handleCreate} mr="10px">
            Create
          </Button>
          <Menu />
        </Flex>
      </Flex>
      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())} pe="10px" key={index} borderColor={borderColor}>
                  <Flex justify="space-between" align="center" fontSize={{ sm: "10px", lg: "12px" }} color="gray.400">
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
              <Th borderColor={borderColor}>
                <Flex justify="space-between" align="center" fontSize={{ sm: "10px", lg: "12px" }} color="gray.400">
                  Actions
                </Flex>
              </Th>
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            const rowData = row.original;
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = (
                    <Text color={textColor} fontSize="sm" fontWeight="700">
                      {cell.value}
                    </Text>
                  );
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent">
                      {data}
                    </Td>
                  );
                })}
                <Td fontSize={{ sm: "14px" }} minW={{ sm: "150px", md: "200px", lg: "auto" }} borderColor="transparent">
                  <Button onClick={() => handleEdit(rowData)} colorScheme="teal">
                    Edit
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={handleModalClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isNew ? "Create Business Unit" : "Edit Business Unit"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedBusinessUnit && (
              <EditBusinessUnit
                businessUnit={selectedBusinessUnit}
                onClose={handleModalClose}
                onRefresh={handleRefresh}
                isNew={isNew}
              />
            )}
          </ModalBody>
          {/* <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleModalClose}>
              Close
            </Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </Card>
  );
}